<template>
  <div>

      

    
    <div>
      <b-card
        v-if="showPreview"
        :header="uLang('app.inspect_action_document')"
        header-tag="h4"
        class="no-card-padding"
        style="min-width: 100%"
      >

        <div style="margin:20px">
          <div class="text-right">
            <b-btn
              v-if="checks.length > 0"
              v-b-toggle.notes
              variant="success"
            >
              <i class="fa fa-lg fa-eye"></i> {{ uLang("app.toggle_notes") }}
            </b-btn>
          </div>
          
          <div v-if="!componentLoading && canSeeChecks" class="mt-8">
            
            <b-collapse id="notes" class="mt-4">
              <div>
                <h2>{{ uLang("app.notes") }}</h2>
                <b-alert
                  variant="secondary"
                  v-for="check in checks"
                  v-if="check.checker"
                  :key="check.id"
                  show
                  dismissible
                >
                  <div>
                    {{ check.updated_at | date }}, {{ check.checker.full_name }}
                  </div>
                  <div class="use-newlines" v-html="check.notes"></div>
                </b-alert>
              </div>
            </b-collapse>
          </div>

        </div>
        
        <iframe
          v-if="$can('check-action-document-checks')"
          :src="
            route('export.actionprogress.filled', {
              actionProgress: this.actionProgressId,
              downloadType: 'stream',
            })
          "
          class="pull-right"
          frameborder="0"
          style="min-width: 100%; height: 60vh"
        ></iframe>
      </b-card>
    </div>

    <div v-if="(!($hasType('candidate') || $hasType('client'))) && isTrajectoryInspector">
      <component
        :is="!showPreview ? 'div' : 'b-card'"
        v-if="showCheckPanel && $can('check-action-document-checks')"
        :header="uLang('app.approve_or_reject')"
        header-tag="h4"
        class="mt-4"
      >
        <div id="check-form" class="form-group mb-3">
          <!-- Loop template here -->
          <div v-for="(item, index) in template_items" :key="index">
            <label
              :for="item.fieldName"
              class="mt-5 font-weight-bold pen-pink"
              v-html="item.label"
            ></label>
            <div
              v-if="item.subLabel"
              class="mt-2 font-weight-bold pen-purple"
              v-html="item.subLabel"
            ></div>
            <template v-if="item.label.toLowerCase().startsWith('periode')" >
              <Placeholder
                :key="index"
                :text="item.placeholder"
                v-model="form[item.fieldName]"
                :action-document-field-names="action_document_field_names"
                :errors="errors"
                :disabled="true"
                :action-progres-id="actionProgressId"
                :check="true"
                :check-id="checkId"
                @form-dirty-inner="onMainFormDirty"
              />
            </template>
            <template v-else>
              <Placeholder
                :key="index"
                :text="item.placeholder"
                v-model="form[item.fieldName]"
                :action-document-field-names="action_document_field_names"
                :errors="errors"
                :disabled="false"
                :action-progress-id="actionProgressId"
                :check="true"
                :check-id="checkId"
                @form-dirty-inner="onMainFormDirty"
              />
            </template>
            
            <div
              class="clearfix row align-items-center mt-2"
              style="margin-left: 0px"
            >
              <div class="form-check form-check-inline col-3">
                <input
                  class="form-check-input"
                  type="checkbox"
                  :id="`pass-${index}`"
                  v-model="checksData[item.fieldName].passed"
                  true-value="true"
                  false-value="false"
                  @change="
                    updateChecksData(
                      item.fieldName,
                      'passed',
                      $event.target.checked
                    )
                  "
                />
                <label class="form-check-label" :for="`pass-${index}`"
                  >Goedgekeurd</label
                >
              </div>
              <div class="form-group col-9">
                <label :for="`comment-${index}`">Opmerking</label>
                <textarea
                  class="form-control"
                  id="`comment-${index}`"
                  v-model="checksData[item.fieldName].comment"
                  rows="1"
                ></textarea>
              </div>
            </div>
            <div v-if="index == template_items.length - 3">
              <div
                style="margin-top: 15px"
                v-if="ActivitiesUndertaken"
                v-html="ActivitiesUndertaken"
              ></div>
            </div>
          </div>
          <!-- General Comment -->
          <label class="font-weight-bold pen-pink" for="notes">{{
            uLang("app.notes")
          }}</label>
          <textarea
            class="form-control"
            rows="4"
            v-model="notes"
            :required="true"
          ></textarea>
        </div>

        <div class="button-container">
          <div class="left-button">
            <button role="button" class="btn btn-success"
              :disabled="!allCheckboxesChecked"
              @click="approve">
              <i aria-hidden="true" class="fa fa-thumbs-up"></i>
              {{ uLang("app.approve") }}
            </button>
            <button role="button" class="btn btn-danger ml-3" @click="reject">
              <i aria-hidden="true" class="fa fa-thumbs-down"></i>
              {{ uLang("app.to_proceed_feedback") }}
            </button>
          </div>
          
          <!-- If disabling save draft button, delete this margin-right -->
          <!-- <div style="float: right; font-size: 0.7em; margin-top: -1em; margin-right: 140px;"> -->
          <div style="float: right; font-size: 0.7em; margin-top: -1em;">
            <span v-if="switchSaveDraft">
              {{ uLang("app.saving_draft") }}...
            </span>
            <span v-else-if="saveDraftTime != ''" :key="saveDraftTime">
              {{ uLang("app.last_saved_draft") }}: 
              {{ formattedSaveDraftTime }}
              </span>
          </div>

          <!-- Allowing manually save draft -->
          <!-- If disabling save draft button, delete the margin-right for the div above -->
          <!-- <div class="center-button">
            <button role="button" class="btn btn-info"
            @click="saveDraftAdmin(true, true)">
              <i aria-hidden="true" class="fa fa-floppy-o"></i>
              {{ uLang("app.save_draft") }}
            </button>
          </div> -->

        </div>

        <div v-if="template_items.length <= 2">
          <div
            style="margin-top: 15px"
            v-if="ActivitiesUndertaken"
            v-html="ActivitiesUndertaken"
          ></div>
        </div>
      </component>
    </div>

    

    <div v-else>
      <component
        :is="!showPreview ? 'div' : 'b-card'"
        v-if="showCheckPanel && $can('check-action-document-checks')"
        header="Goed-/afkeuren kandidaat"
        header-tag="h4"
        class="mt-4"
      >
        <div>
          <div class="form-group mb-3">
            <label class="font-weight-bold pen-pink" for="notes">Opmerkingen (optioneel)</label>
            <textarea
              class="form-control"
              rows="4"
              v-model="notes"
              :required="true"
            ></textarea>
          </div>
          <button
            role="button"
            class="btn btn-success"
            @click="approve"
          >
            <i class="fa fa-thumbs-up" aria-hidden="true"></i>
            {{ uLang("app.approve") }}
          </button>
          <button
            role="button"
            class="btn btn-danger ml-3"
            @click="reject"
          >
            <i class="fa fa-thumbs-down" aria-hidden="true"></i>
            {{ uLang("app.to_proceed_feedback") }}
          </button>
        </div>
      </component>
    </div>

    <!-- DEBUG 
    <div v-if="!($hasType('candidate'))">No hasType Candidate</div>
    <div v-if="!($hasType('client'))">No hasType Client</div>
    <div v-if="isTrajectoryInspector">isTrajectoryInspector</div>  
    -->
    <div v-if="this.agreedStatus===0" style="font-weight: 100; font-size: 0.8em;">Note: this report is rejected and currently being reviwed by the coach.</div>  
    <div v-else-if="this.agreedStatus===1" style="font-weight: 100; font-size: 0.8em;">Note: this report is already approved.</div>  

    <b-modal size="xl" ref="my-modal" hide-footer title="" :close-on-backdrop="false">
      <b-card :header="uLang('app.edit')" header-tag="h4" class="bg-default-card">
        <div id="my-modal-content" class="d-block">
          <div class="form-group row">
            <label for="subject" class="col-form-label col-md-3 col-xl-2 col-sm-12">
              {{ uLang('app.subject_or_short_description') }}:*
            </label> 
            <div class="col-md-9 col-xl-10 col-sm-12">
              <textarea rows="3" id="subject" v-model="modalSubject" name="subject" required="required" class="form-control"></textarea>
            </div>
          </div>
          <div class="form-group row">
            <label for="body" class="col-form-label col-md-3 col-xl-2 col-sm-12">
              {{ uLang('app.body_or_explanation') }}:*
            </label>
            <div class="col-md-9 col-xl-10 col-sm-12">
              <textarea rows="3" id="body" name="body" v-model="modalBody" required="required" class="form-control"></textarea>
            </div>
          </div>
          <div class="form-group row">
            <label for="reporting_log_include" class="col-form-label col-md-3 col-xl-2 col-sm-12">
              {{ uLang('app.reporting_log_include') }}:
            </label>
            <div class="col-md-9 col-xl-10 col-sm-12">
              <select style="width: 100%; padding: 6px; border: 1px solid #ccc;" name="reporting_log_include" id="reporting_log_include" v-model="modalReportLogInclude">
                <option class="multiselect__element" value="yes">{{ uLang('app.yes') }}</option>
                <option class="multiselect__element" value="no">{{ uLang('app.no') }}</option>
              </select>
            </div>
          </div>

          <div class="form-group row">
            <label for="duration" class="col-form-label col-md-3 col-xl-2 col-sm-12">
              {{ uLang('app.duration') }}:
            </label>
            <div class="col-md-9 col-xl-10 col-sm-12">
              <TimeInput
                v-model="modalDuration"
                name="duration"
                :required="false"
              />
            </div>
          </div>  

          <div class="form-group row">
            <label for="body" class="col-form-label col-md-3 col-xl-2 col-sm-12">
              {{ uLang('app.action_date') }}:*
            </label>
            <div class="col-md-9 col-xl-10 col-sm-12">
              <vue-pikaday
                class="form-control"
                :options="{
                    format: 'DD-MM-YYYY',
                    i18n: {
                        previousMonth : 'Vorige maand',
                        nextMonth     : 'Volgende maand',
                        months        : ['Januari','Februari','Maart','April','Mei','Juni','Juli','Augustus','September','Oktober','November','December'],
                        weekdays      : ['Zondag','Maandag','Dinsdag','Woensdag','Donderdag','Vrijdag','Zaterdag'],
                        weekdaysShort : ['Zo','Ma','Di','Wo','Do','Vr','Za']
                    },
                    yearRange: [1900,2030],
                    theme: 'rea-theme'
                }"
                v-model="modalActionDate"
              />
            </div>
          </div>
        </div>
        <b-button variant="btn btn-brand" @click="hideModal">{{ uLang('app.save') }}</b-button>
      </b-card>
    </b-modal>

  </div>
</template>

<script>
import Form from "~/Form/Form";
import Placeholder from "~/components/forms/admin/relation/trajectory-enrolment/action-document-versions/elements/placeholder.vue";
import { SuccessAlert, ErrorAlert, WarningAlert, ConfirmationAlert } from "~/Swals";
import { Textarea as FormTextarea } from "~/Form/elements";
import FormMixin from "~/mixins/form";
import { mapGetters } from 'vuex';
import TimeInput from "~/components/elements/selects/TimeInput.vue";

export default {
  name: "create",

  mixins: [FormMixin],

  

  components: {
    Placeholder,
    FormTextarea,
    TimeInput,
  },

  props: {
    relationId: {
      required: true,
    },
    trajectoryEnrolmentId: {
      required: true,
    },
    milestoneProgressId: {
      required: true,
    },
    actionProgressId: {
      required: true,
    },
    checkId: {
      required: true,
    },
    showPreview: {
      type: Boolean,
      required: false,
      default: true,
    },
  },

  data() {
    return {
      notes: "",
      checks: [],
      template: null,
      working: false,
      showCheckPanel: false,
      componentLoading: true,
      template_items: [],
      ActivitiesUndertaken: "",
      isFormDirty: false,
      dataLoaded: false,
      formTitles: [],
      data: null,
      regexChecker: /^\[form\.([a-zA-Z_]+)\.([a-zA-Z0-9]+)\]$/i,
      action_document_field_names: [],
      action_document_version_id: [],
      errors: {},
      checksData: {},
      form: new Form({
        submit_type: "submit",
        deny_terms_reason: "",
      }),
      typeCheck: "",

      modalLogId: 0,
      modalSubject: "",
      modalBody: "",
      modalReportLogInclude: "yes",
      modalDuration: '',
      modalActionProgressId: 0,
      modalActionDate: "",
      draftInterval: null,
      switchSaveDraft: false,
      saveDraftTime: '',
      tabId: "",
      deviceId: "",
      autoKicked: false,
      isLockedWarning: false,
      agreedStatus: null,
    };
  },

  async mounted() {
    // This code was here, but Pao set it to null on beforeDestroy, commenting it to not mess with it - maybe should delete
    // window.onbeforeunload = (e) => {
    //   if (this.isFormDirty) {
    //     const message = "Changes you made may not be saved.";
    //     e.returnValue = message;
    //     this.coachRelease(); // Release the lock when leaving the page
    //     return message;
    //   }
    //   this.adminRelease(); // Release the lock when leaving the page
    // };

    this.draftInterval = setInterval(() => {
      this.saveDraftAdmin();
    }, 30000);

    // Checks if the report is locked by other user (probably took over)
    this.lockCheckInterval = setInterval(() => {
      this.checkLockValidity();
    }, 3000);

    
  },

  beforeDestroy() {
    window.onbeforeunload = null; // Why did Pao do this???

    window.removeEventListener('unload', this.handleWindowUnload);
    this.handleWindowUnload();

    // if (this.isFormDirty && !this.autoKicked) {
    //   // Force saveDraft on leaving the page  
    //   const filteredForm = this.filterForm();

    //   const payload = {
    //     notes: this.notes,
    //     checksData: this.checksData,
    //     form: filteredForm,
    //   };

    //   const blob = new Blob([JSON.stringify(payload)], {
    //     type: 'application/json',
    //   });

    //   // Use navigator.sendBeacon to send (POST) the form because the page is unloading so we cannot use axios
    //   navigator.sendBeacon(
    //     route('relations.trajectory-enrolments.milestone-progresses.action-progresses.action-document.save-draft-admin', {
    //       action_progress: this.actionProgressId,
    //       check: this.checkId,
    //     }),
    //     blob
    //   );

    //   console.log("Saving draft before closing...");
        
    // }

    // // Only release lock if is the user leaving the page - not if it's autokick because other user took over this report
    // if(!this.autoKicked) {
    //   this.adminRelease();
    // }

    if (this.draftInterval) {
      clearInterval(this.draftInterval);
    }

    if (this.lockCheckInterval) {
      clearInterval(this.lockCheckInterval);
    }
  },

  beforeRouteLeave(to, from, next) {
    if (this.isFormDirty) {
      const confirmed = window.confirm("Leave without saving? Changes will be saved as a draft.");
      if (confirmed) {
        next(); 
      } else {
        return; 
      }
    } else {
      next(); 
    }
  },

  computed: {
    ...mapGetters([
      'authUser',
    ]),
    canSeeChecks() {
      return !($hasType("client") || $hasType("candidate"));
    },
    allPassed() {
      return this.checks.every((check) => check.passed);
    },
    allCheckboxesChecked() {
      return this.template_items.every(
        (item) => String(this.checksData[item.fieldName]?.passed) === "true"
      );
    },
    isTrajectoryInspector() {
      return this.typeCheck === "trajectory_inspector";
    },

    formattedSaveDraftTime() {
      if (!this.saveDraftTime) return '';

      const m = moment(this.saveDraftTime, moment.ISO_8601, true);

      if (m.isValid()) {
        return m.format('DD/MM/YYYY HH:mm:ss');
      }

      // Otherwise it's a message
      return this.saveDraftTime;
    },
  },

  async created() {
    this.tabId = this.generateTabId();
    this.deviceId = this.generateDeviceId();

    window.addEventListener('unload', this.handleWindowUnload);

    const response = await axios.get(
      route('lock.admin.check', { action_progress: this.actionProgressId }),
      {
        params: {
          deviceId: this.deviceId,
        }
      }
    );

    if (response.data.locked) {
      this.isLockedWarning = true; // To avoid reload on checkLockValidity()

      await new ConfirmationAlert({
        text: this.uLang(response.data.message),
        title: this.uLang("app.error"),
        entity: "report", // anything, just to satisfy the default message if needed
        cancelButtonText: this.uLang("app.close"),
        continueButtonText: this.uLang("app.release_report")
      }).show()
        .then(async () => {
          // User clicked "Take over"
          this.isLockedWarning = false;
          await this.lockReport(); // this will change the lock => "auto-release" + "new lock"
        })
        .catch(() => {
          // User clicked "Close"
          this.$router.push({ name: "dashboard" });
        });
    } else {
      await this.lockReport();
    }

    await this.retrieveTemplate(); // Added await to be sure data is loaded before things as fetchChecksData
    const { data } = await window.axios.get(
      route("action-document.check.show", { check: this.checkId })
    );

    this.notes = data.notes != null ? data.notes : "";

    this.typeCheck = data.type;

    this.checks = data.action_progress.checks;

    this.agreedStatus = data.agreed
    if (data.agreed === null) {
      this.showCheckPanel = true;
    }

    await this.fetchChecksData();
    this.watchChecksData();
    await this.fetchNotesData();

    if($hasType('candidate') || $hasType('client')) {
      this.notes = "";
    }

    this.componentLoading = false;
    this.dataLoaded = true;

    window.axios
      .get(
        route(
          "relations.trajectory-enrolments.milestone-progresses.action-progresses.action-document.get-ongoing-activity",
          {
            relation: this.relationId,
            trajectory_enrolment: this.trajectoryEnrolmentId,
            milestone_progress: this.milestoneProgressId,
            action_progress: this.actionProgressId,
          }
        )
      )
      .then(({ data }) => {
        this.ActivitiesUndertaken = data;

        this.$nextTick(() => {
          const buttons = document.querySelectorAll('.openModalButton');
          buttons.forEach(button => {
            button.addEventListener('click', (event) => {
              const log_id = event.currentTarget.getAttribute('data-log-id');

              window.axios.get("/api/admin/logs/" + log_id)
                .then(({ data }) => {
                  this.modalLogId = data.id;
                  this.modalSubject = data.subject;
                  this.modalBody = data.body;
                  this.modalReportLogInclude = (data.appears_in_reports.length > 0 ? "yes" : "no");
                  this.modalActionProgressId = this.actionProgressId;

                  // Get the duration from the report item
                  const reportItem = data.appearsInReports.find(item => item.pivot && item.pivot.action_progress_id == this.actionProgressId);
                  this.modalDuration = reportItem && reportItem.pivot ? reportItem.pivot.duration : '';
                  
                  const [day, month, year] = data.activity_date.split("-");
                  const parsedDate = new Date(year, month - 1, day);

                  this.modalActionDate = parsedDate;

                  this.showMyModal();
                });
            });
          });
          
        });
      });
  },

  methods: {
    generateTabId() {
      if (!sessionStorage.getItem("tabId")) {
          sessionStorage.setItem("tabId", Math.random().toString(36).substr(2, 9));
      }
      return sessionStorage.getItem("tabId");
    },

    generateDeviceId() {
      if (!localStorage.getItem("deviceId")) {
        localStorage.setItem("deviceId", Math.random().toString(36).substr(2, 10));
      }
      return localStorage.getItem("deviceId");
    },

    async lockReport() {
      await axios.post(route('lock.admin.tolock', 
        { 
          action_progress: this.actionProgressId
        }), 
        {
          relationId: this.authUser.id,
          tabId: this.tabId,
          deviceId: this.deviceId,
        }
      );
    },
    showMyModal() {
      this.$refs['my-modal'].show();
    },
    hideModal() {
      let formattedDate = ('0' + this.modalActionDate.getDate()).slice(-2) + '-' +
                    ('0' + (this.modalActionDate.getMonth() + 1)).slice(-2) + '-' +
                    this.modalActionDate.getFullYear();

      window.axios.post("/api/admin/logs/save/", {
        action_date: formattedDate,
        log_id: this.modalLogId,
        subject: this.modalSubject,
        body: this.modalBody,
        duration: this.modalDuration,
        action_progress_id: this.modalActionProgressId,
        reporting_log: this.modalReportLogInclude === "yes" ? 1 : 0,
        form_coach_page: 1
      })
      .then(response => {
        document.querySelector('#in-report-span-subject-log-id-' + this.modalLogId).textContent = response.data.data.subject;
        document.querySelector('#in-report-content-p-log-id-' + this.modalLogId).textContent = response.data.data.body.replace(/\n/g, '<br>');
        let [year, month, day] = response.data.data.action_date.split('-');
        document.querySelector('#in-report-span-action-date-log-id-' + this.modalLogId).textContent = `${day}-${month}-${year}`;
        if (response.data.reporting_log === 0) {
          document.querySelector('#in-report-wrapper-log-id-' + this.modalLogId).innerHTML = "";
        }
        this.$refs['my-modal'].hide()
      })
      .catch(error => {
          console.error(error); // handle error
      });
    },
    watchChecksData() {
      Object.keys(this.checksData).forEach((key) => {
        this.$watch(
          () => this.checksData[key].comment,
          (newVal, oldVal) => {
            if (this.dataLoaded) {
              this.isFormDirty = true;
            }
          }
        );

        this.$watch(
          () => this.checksData[key].passed,
          (newVal, oldVal) => {
            if (this.dataLoaded) {
              this.isFormDirty = true;
            }
          }
        );

         this.$watch(
          () => this.notes,
          (newVal, oldVal) => {
            if (this.dataLoaded) {
              this.isFormDirty = true;
            }
          }
        );
      });
    },
    approve() {
      this.doRequest("approve", (data) => {
        if (data.status == "success") {

          this.adminRelease(); // Release the lock when approving

          this.isFormDirty = false;
          this.showCheckPanel = false;
          return new SuccessAlert({
            text: this.uLang("app." + data.text),
          }).show();
        }

        return new ErrorAlert({
          text: this.uLang("app.cant_be_checked_right_now"),
        }).show();
      });
    },

    filterForm() {
      // Filter the form to only include keys that match the regex pattern
      return Object.keys(this.form)
        .filter(key => /^[A-Za-z0-9]{10}$/.test(key)) // Match keys with the regex pattern
        .reduce((acc, key) => {
          const value = this.form[key];
          if (value !== null && value !== 'null') { // Exclude null values
            acc[key] = value;
          }
          return acc;
        }, {});
    },

    async saveDraftAdmin(doAlertToast = false, force = false) {
      if(this.switchSaveDraft && !force) {
        console.log('Another saveDraft is already in progress, skipping this one.');
        return;
      }

      this.switchSaveDraft = true;

      // create_draft_backup: true only when user clicks "Save draft" (manual), not on 30s autosave
      const createDraftBackup = doAlertToast === true;
      try {
        const { data } = await window.axios.post(
          route(
            "relations.trajectory-enrolments.milestone-progresses.action-progresses.action-document.autosave-notes",
            {
              action_progress: this.actionProgressId,
              check: this.checkId,
            }
          ),
          {
            notes: this.notes,
            form: this.filterForm(),
            checksData: this.checksData,
            force,
            create_draft_backup: createDraftBackup,
          }
        );

        this.isFormDirty = false;
        this.saveDraftTime = data.no_drafts ? data.message : new Date().toISOString();

        if (doAlertToast === true) {
          return new SuccessAlert({
            text: uLang("app.save_draft_completed"),
          }).show();
        }
      } finally {
        this.switchSaveDraft = false;
      }
    },

    onMainFormDirty() {
      if (this.dataLoaded) {
        this.isFormDirty = true;
      }
    },

    reject() {
      this.doRequest("reject", (data) => {
        if (data.status == "success") {

          this.adminRelease(); // Release the lock when rejecting

          this.isFormDirty = false;
          this.showCheckPanel = false;
          return new SuccessAlert({
            text: this.uLang("app." + data.text),
          }).show();
        }

        return new ErrorAlert({
          text: this.uLang("app.cant_be_checked_right_now"),
        }).show();
      });
    },
    async fetchNotesData() {
      // Notes are loaded from action-document.check.show response in created()
    },
    /**
     * Use this method to wait for the main retrieveTemplate() to finish. I added await to it, but just in case
     *   with this we will be sure it will work as expected even if the await returs too early for whatever reason.
     * @param timeout 
     */
    async waitForChecksData(timeout = 3000) {
      return new Promise((resolve, reject) => {
        const interval = 50;
        const start = Date.now();

        const check = () => {
          if (Object.keys(this.checksData).length > 0) {
            resolve();
          } else if (Date.now() - start >= timeout) {
            reject(new Error("checksData did not load in time"));
          } else {
            setTimeout(check, interval);
          }
        };

        check();
      });
    },
    async fetchChecksData() {
      try {
        await this.waitForChecksData(); // Wait until checksData is ready
      } catch (error) {
        console.warn("checksData not yet loaded (timeout)");
        return;
      }
      
      try {
        // Make the API call to fetch the latest checks data.
        const response = await window.axios.get(
          "/api/action-progress/" + this.actionProgressId + "/latest-checks"
        );

        response.data.forEach((checkData) => {
          // Find the corresponding item in template_items by ID.
          const item = this.template_items.find(
            (item) => item.id === checkData.action_document_field_names_id
          );

          if (item) {
            // Use Vue's reactivity system to update the checksData object.
            this.$set(
              this.checksData[item.fieldName],
              "comment",
              checkData.notes || ""
            );

            // Update the checkbox value; assuming 'agreed' is a boolean in your response.
            this.$set(
              this.checksData[item.fieldName],
              "passed",
              checkData.agreed ? "true" : "false"
            );
          }
        });

        // After the loop, your checksData object should have updated values for checkboxes and comments.
      } catch (error) {
        console.error("Failed to fetch latest checks data:", error);
        this.$snotify.error("Failed to load latest checks data.");
      }
    },

    async doRequest(type, callback) {

      this.template_items.forEach(item => {
        if (this.checksData[item.fieldName]) {
          this.$set(this.checksData[item.fieldName], 'label', item.label);
          this.$set(this.checksData[item.fieldName], 'subLabel', item.subLabel);
        }
      });

      const { data } = await window.axios.post(
        route(
          "relations.trajectory-enrolments.milestone-progresses.action-progresses.action-document." +
            type,
          {
            relation: this.relationId,
            trajectory_enrolment: this.trajectoryEnrolmentId,
            milestone_progress: this.milestoneProgressId,
            action_progress: this.actionProgressId,
            check: this.checkId,
          }
        ),
        {
          notes: this.notes,
          checksData: this.checksData,
          form: this.form
        }
      );

      callback(data);
      this.$emit("checked");
    },
    // async retrieveTemplate() {
    //   window.axios
    //     .get(
    //       route(
    //         "relations.trajectory-enrolments.milestone-progresses.action-progresses.action-document.index",
    //         {
    //           relation: this.relationId,
    //           trajectory_enrolment: this.trajectoryEnrolmentId,
    //           milestone_progress: this.milestoneProgressId,
    //           action_progress: this.actionProgressId,
    //         }
    //       )
    //     )
    //     .then(({ data }) => {
    //       for (let index in data.action_document_version
    //         .action_document_field_names) {
    //         let field =
    //           data.action_document_version.action_document_field_names[index];
    //         if (!this.checksData[field.name]) {
    //           this.$set(this.checksData, field.name, {
    //             id: field.id,
    //             comment: "",
    //             passed: false,
    //           });
    //         }

    //         this.form.originalData[field.name] = null;
    //         this.form[field.name] = null;
    //         if (field.action_document_filled_data.length > 0) {
    //           let value = this.getValue(field);
    //           this.form.originalData[field.name] = value;
    //           this.form[field.name] = value;
    //         }
    //       }
    //       this.data = data;

    //       this.splitUpTemplate(
    //         data.action_document_version.template,
    //         data.action_document_version.action_document_field_names
    //       );
    //       this.action_document_field_names =
    //         data.action_document_version.action_document_field_names;
    //       this.checks = data.checks;
    //       this.action_document_version_id = data.action_document_version_id;
    //       this.componentLoading = false;
    //     })
    //     .catch((error) => {
    //       this.$snotify.error(error.response.data.message);
    //     });
    // },
    async retrieveTemplate() {
      try {
        const { data } = await window.axios.get(
          route(
            "relations.trajectory-enrolments.milestone-progresses.action-progresses.action-document.index",
            {
              relation: this.relationId,
              trajectory_enrolment: this.trajectoryEnrolmentId,
              milestone_progress: this.milestoneProgressId,
              action_progress: this.actionProgressId,
            }
          )
        );

        for (let field of data.action_document_version.action_document_field_names) {
          if (!this.checksData[field.name]) {
            this.$set(this.checksData, field.name, {
              id: field.id,
              comment: "",
              passed: false,
            });
          }

          this.form.originalData[field.name] = null;
          this.form[field.name] = null;

          if (field.action_document_filled_data.length > 0) {
            let value = this.getValue(field);
            this.form.originalData[field.name] = value;
            this.form[field.name] = value;
          }
        }

        this.data = data;
        this.splitUpTemplate(
          data.action_document_version.template,
          data.action_document_version.action_document_field_names
        );
        this.action_document_field_names = data.action_document_version.action_document_field_names;
        this.checks = data.checks;
        this.action_document_version_id = data.action_document_version_id;
        this.componentLoading = false;
      } catch (error) {
        this.$snotify.error(error.response.data.message);
      }
    },
    splitUpTemplate(template, actionDocumentFieldNames) {
      // Regex to find form fields
      let regex = /\[form\.([a-zA-Z_]+)\.([a-zA-Z0-9]+)\|?(.*?)\]/gi;
      let matches;
      let templateItems = [];

      while ((matches = regex.exec(template)) !== null) {
        let label = "";
        let subLabel = "";
        let usedLabels = new Set();

        let closestTdStartIndex = template
          .substring(0, matches.index)
          .lastIndexOf("<td>");
        if (closestTdStartIndex > -1) {
          let closestTdEndIndex = template.indexOf(
            "</td>",
            closestTdStartIndex
          );
          if (closestTdEndIndex > -1 && closestTdEndIndex > matches.index) {
            // Now find the <td> just before this one for the label
            let labelTdEndIndex = template.lastIndexOf(
              "</td>",
              closestTdStartIndex
            );
            if (labelTdEndIndex > -1) {
              let labelTdStartIndex = template.lastIndexOf(
                "<td>",
                labelTdEndIndex
              );
              if (labelTdStartIndex > -1) {
                label = template
                  .substring(labelTdStartIndex + 4, labelTdEndIndex)
                  .replace(/<[^>]+>/g, "")
                  .trim();
              }
            }
          }

          // If no suitable label was found in <td>, find the nearest <mark class="pen-pink"> before the [form...]
          if (!label) {
            let markIndex = template
              .substring(0, matches.index)
              .lastIndexOf('<mark class="pen-pink">');
            if (markIndex > -1) {
              let markEndIndex = template.indexOf("</mark>", markIndex);
              if (markEndIndex > -1 && markEndIndex < matches.index) {
                label = template
                  .substring(
                    markIndex + '<mark class="pen-pink">'.length,
                    markEndIndex
                  )
                  .replace(/<[^>]*>/g, "")
                  .trim();
              }
            }
          }
        }

        let purpleMarkIndex = template
          .substring(0, matches.index)
          .lastIndexOf('<mark class="pen-purple">');
        if (purpleMarkIndex > -1) {
          let purpleMarkEndIndex = template.indexOf("</mark>", purpleMarkIndex);
          if (purpleMarkEndIndex > -1 && purpleMarkEndIndex < matches.index) {
            subLabel = template
              .substring(
                purpleMarkIndex + '<mark class="pen-purple">'.length,
                purpleMarkEndIndex
              )
              .replace(/<[^>]*>/g, "")
              .trim();
          }
        }

        if (subLabel == "in opdracht van") {
          subLabel = "";
        }

        if (!label && subLabel) {
          label = subLabel;
          subLabel = "";
        }

        label = label || matches[3] || matches[2];

        if (usedLabels.has(label)) {
          label = ""; 
        } else {
          usedLabels.add(label);
        }

        let fieldObject = actionDocumentFieldNames.find(
          (field) => field.name === matches[2]
        );
        let fieldId =
          fieldObject && fieldObject.action_document_filled_data[0]
            ? fieldObject.action_document_filled_data[0]
                .action_document_field_name_id
            : null;

        let item = {
          placeholder: matches[0],
          fieldName: matches[2],
          label: label,
          subLabel: subLabel,
          id: fieldId,
        };
        templateItems.push(item);
      }

      this.template_items = templateItems;
    },
    getValue(field) {
      let data = field.action_document_filled_data;

      if (data.length > 1) {
        return _.last(_.uniqBy(data, "version")).value;
      }
      return data[0].value;
    },
    updateChecksData(fieldName, key, value) {
      if (!this.checksData[fieldName]) {
        this.$set(this.checksData, fieldName, { comment: "", passed: "false" });
      }
      this.$set(this.checksData[fieldName], key, value ? "true" : "false");
    },

    // Release the lock
    coachRelease() {
      const data = JSON.stringify({ 
        relation_id: this.authUser.id,
        tabId: this.tabId,
        deviceId: this.deviceId,
      });
      navigator.sendBeacon(route('lock.coach.release', {action_progress: this.actionProgressId}), data);
    },
    adminRelease() {
      const data = JSON.stringify({ 
        relation_id: this.authUser.id,
        tabId: this.tabId,
        deviceId: this.deviceId,
      });
      navigator.sendBeacon(route('lock.admin.release', {action_progress: this.actionProgressId}), data);
    },

    /**
     * Actions to do on uloading the page - even if user closes the tab/browser
     */
    handleWindowUnload() {
      if (this.isFormDirty && !this.autoKicked) {
        const payload = {
          notes: this.notes,
          form: this.filterForm(),
          checksData: this.checksData,
        };
        const blob = new Blob([JSON.stringify(payload)], { type: 'application/json' });
        navigator.sendBeacon(
          route('relations.trajectory-enrolments.milestone-progresses.action-progresses.action-document.autosave-notes', {
            action_progress: this.actionProgressId,
            check: this.checkId,
          }),
          blob
        );
      }

      // Only release lock if is the user leaving the page - not if it's autokick because other user took over this report
      if(!this.autoKicked) {
        this.adminRelease();
      }
    },

    /**
     * Checks if this report is already locked by other user (probably took over) to "kick off" this user
     */
    async checkLockValidity() {

      // Only check if we are not already showing the warning
      if(!this.isLockedWarning) {
        
        const response = await axios.get(route('lock.admin.validate', {
          action_progress: this.actionProgressId,
        }), {
          params: {
            deviceId: this.deviceId,
          }
        });

        if (!response.data.valid) {
          this.autoKicked = true;
          window.location.reload(); // Reload to trigger the takeover warning
        }
      }
    },

  },
};
</script>

<style lang="css">
.no-card-padding.card .card-block {
  padding: 0;
}

.button-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.left-button {
  display: flex;
  justify-content: flex-start;
}

.center-button {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 1000;
}

.right-button {
  display: flex;
  justify-content: flex-end;
}
</style>
